import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { map as _map } from 'lodash';

import { useDeals } from '../lib/deals';
import { DealTiles } from '@lce/gatsby-theme-bannermatic/src/templates/DealTiles';

interface DealmaticProps {
  baseUrl: string;
  locale: string;
}

const queryClient = new QueryClient();

export const Dealmatic: React.FC<DealmaticProps> = props => {
  return (
    <QueryClientProvider client={queryClient}>
      <DealManager {...props} />
    </QueryClientProvider>
  );
};

const DealManager: React.FC<DealmaticProps> = ({ baseUrl, locale }) => {
  const { data: deals, isLoading } = useDeals({ baseUrl, locale });

  return !isLoading && deals ? (
    <DealTiles deals={ deals } />
  ) : null;
};
